import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ChangeClientDialogController',
            ChangeClientDialogController
        );

    /** @ngInject */
    function ChangeClientDialogController(
        $scope,
        $state,
        CompaniesFactory,
        FormVerificationService,
        ngDialog,
        toastr
    ) {
        var vm = this;
        var companyId;

        init();

        function init() {
            companyId = $scope.ngDialogData.company;

            vm.issue = $scope.ngDialogData.issue;
            vm.save = save;

            getClients();
        }

        function save() {
            CompaniesFactory.reassignClient(companyId, vm.issue.id, {
                client_id: vm.client,
            }).then(
                function (response) {
                    toastr.success('Zapisano zmiany');
                    ngDialog.close();
                    $state.go('company_employee.issue_list.details', {
                        issue_id: response.data.issue_id,
                    });
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }

        function getClients() {
            CompaniesFactory.readHousingAssociations(companyId, {
                page_size: 1000,
            }).then(function (response) {
                vm.clients = response.data.results;

                setClient();
            });
        }

        function setClient() {
            if (vm.issue.customer) {
                vm.client = vm.issue.customer.party_uuid;
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-client-dialog/change-client.controller.ts